import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, transition } from './neonUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Menu', 'cyberTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      background: 'transparent !important',

      [`${componentCls}-item`]: {
        borderRadius: '2px !important',
        transition,
        position: 'relative' as const,

        '&:hover': {
          background: `${cyan[500]}0a !important`,
          color: `${cyan[400]} !important`,
        },

        // 选中态：左侧荧光条
        [`&${componentCls}-item-selected`]: {
          background: `${cyan[500]}10 !important`,
          color: `${cyan[500]} !important`,

          '&:after': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: '20%',
            bottom: '20%',
            width: 2,
            background: cyan[500],
            boxShadow: `0 0 6px ${cyan[500]}80`,
            borderRadius: 1,
          },
        },
      },

      // 子菜单标题
      [`${componentCls}-submenu-title`]: {
        borderRadius: '2px !important',
        transition,

        '&:hover': {
          background: `${cyan[500]}0a !important`,
          color: `${cyan[400]} !important`,
        },
      },

      // 分组标题
      [`${componentCls}-item-group-title`]: {
        color: `${cyan[700]} !important`,
        fontSize: '11px',
        textTransform: 'uppercase' as const,
        letterSpacing: '1px',
      },
    },
  }
})
